import { Id } from '@/infra/id'
import type { CallCenterContactResource } from '@/features/freshbooks/api/resources/call-center-contacts'
import type { CallCenterContact } from './CallCenterContact'

export function mapCallCenterContactResourceToCallCenterContact(
  resource: CallCenterContactResource,
): CallCenterContact {
  return {
    id: resource.id,
    email: resource.email,
    firstName: resource.firstname,
    lastName: resource.lastname,
    phone: resource.phone,
    contactType: resource.contact_type,
    signedUpForWaitlist: resource.signed_up_for_waitlist,
    waitlistWorkspaceId: Id(resource.waitlist_workspace_id),
    createdAt: new Date(resource.createdAt),
    updatedAt: new Date(resource.updatedAt),
  }
}
